/* eslint-disable jsx-a11y/img-redundant-alt */
import File from "../Images/File.png";
import G from "../Images/Icons/G.png";
import LB from "../Images/Icons/LB.png";
import LO from "../Images/Icons/LO.png";
import P from "../Images/Icons/P.png";
import R from "../Images/Icons/R.png";
import Pur from "../Images/Icons/Pur.png";
import img1 from "../Images/CounterImg/img1.jpg"
import img2 from "../Images/CounterImg/img2.jpg"
import img3 from "../Images/CounterImg/img3.jpg"
import img4 from "../Images/CounterImg/img4.jpg"
import img5 from "../Images/CounterImg/img5.jpg"
import img6 from "../Images/CounterImg/img6.jpg"
import img7 from "../Images/CounterImg/img7.jpg"
import img8 from "../Images/CounterImg/img8.jpg"
import img9 from "../Images/CounterImg/img9.jpg"
import img10 from "../Images/CounterImg/img10.jpg"
import img11 from "../Images/CounterImg/img11.jpg"
import img12 from "../Images/CounterImg/img12.jpg"
const Stack = () => {

    const cardData = [
        {
          id: 1,
          icon: P,
          title: "Website Development",
          subtitle: "for Businesses and Individuals",
          description:
            "We create custom, responsive websites that engage visitors and drive conversions. Our designs are tailored to your brand, ensuring a seamless user experience across all devices. With a focus on aesthetics, functionality, and performance, we build websites that not only look great but also help grow your business and maximize online success.",
          image1: img1,
          image2: img2,
          color:'#FF4FE4'
        },
        {
          id: 2,
          icon: LO,
          title: "Application Development",
          subtitle: "for Innovative and Scalable Solutions",
          description:
            "We build high-performance native and cross-platform mobile apps for iOS and Android. Our solutions enhance user engagement, streamline operations, and support business growth. From enterprise tools to sleek consumer apps, we ensure seamless functionality and exceptional user experience.",
          image1: img3,
          image2: img4,
          color:'#FF927B'
        },
        {
          id: 3,
          icon: LB,
          title: "Software Development",
          subtitle: "for Scalable and Efficient Solutions",
          description:
            "We deliver custom software solutions that streamline operations, boost efficiency, and enhance productivity. Designed for seamless integration, our scalable and secure systems—from automation to enterprise tools—help your business stay ahead in a competitive market.",
          image1: img5,
          image2: img6,
          color:'#51FBD6'
        },
        {
          id: 4,
          icon: G,
          title: "AI Development",
          subtitle: "for Intelligent and Automated Solutions",
          description:
            "We create intelligent solutions powered by machine learning and artificial intelligence to enhance automation, decision-making, and efficiency. Our AI-driven applications help businesses analyze data, optimize processes, and deliver personalized user experiences. From chatbots to predictive analytics, we develop scalable and innovative AI solutions tailored to your unique needs, driving smarter business outcomes.",
          image1: img7,
          image2: img8,
          color:'#B7E333'
        },
        {
          id: 5,
          icon: Pur,
          title: "E-Commerce",
          subtitle: "for Seamless Online Selling and Growth",
          description:
            "We build secure, scalable online stores with seamless payment integration to enhance user experience and drive sales. Our e-commerce solutions include custom design, mobile optimization, and powerful backend management. Whether you're a startup or an established brand, we create high-performance platforms that ensure smooth transactions, customer engagement.",
          image1: img9,
          image2: img10,
          color:'#AA35DC'
        },
        {
            id: 6,
            icon: R,
            title: "UI/UX Design",
            subtitle: "for Engaging and User-Centric Experiences",
            description:
              "We craft intuitive, user-focused designs that blend aesthetics with functionality. From wireframes to prototypes, our UI/UX solutions ensure seamless navigation, responsive layouts, and engaging experiences that elevate your brand and delight users.",
            image1: img11,
            image2: img12,
            color:'#D72D2D'
          },
      ];

  return (
    <div className="flex justify-center  items-center w-full">

       
      <div className="w-full bg-[#0F172B]">
        <ul className="grid grid-cols-1 gap-16 pb-16 mb-16">
          
          {/* Card 1 with Image & Overlay Text */}
        {cardData.map((items,index)=>(
          <li className="sticky  top-0 pt-6">
            <div className="relative flex justify-center items-center md:h-[87vh]">
              {/* Background Image */}
              <img  src={File}  alt="Background" className='md:h-full h-[300px] w-[95vw]'/>
              {/* Overlay Text */}
              <div className="absolute top-1/2 left-40 md:left-[400px] lg:left-[420px] xl:left-[600px] transform -translate-x-1/2 -translate-y-1/2 px-6 py-3 rounded-lg ">
                    <div className='flex mt-5'>
                        <div className='md:w-[400px] mt-5'>
                            <img src={items.icon} alt="" className='w-15 h-15 md:w-25 md:h-25'/>
                            <h1 className='text-[20px] md:text-[40px] lg:text-[44px] xl:text-[50px] font-[700]' style={{fontFamily:'PT Sans',color:items.color}}>{items.title}</h1>
                            <h1 className='text-white text-[20px] md:text-[28px] font-[700] xl:text-[42px] lg:text-[38px]' style={{fontFamily:'Allison'}}>{items.subtitle}</h1>
                            <p className='md:text-[16px] xl:w-[600px] md:w-[400px] w-[275px] lg:text-[20px] text-[10px] xl:text-[20px] font-[Nunito] text-white font-[300]'>{items.description}</p>
                        </div>
                        <div className="relative hidden md:block flex lg:mt-20 flex-row xl:left-[180px] lg:bottom-[100px] gap-4 w-[300px]">
                            <img   src={items.image1}   alt="Image 1"   className="lg:h-[400px] absolute xl:w-[300px] xl:h-[400px] xl:right-20 lg:left-25 lg:top-10  lg:w-[250px] xl:h-[370px] xl:w-[275px] md:w-[170px] md:h-[275px]  object-cover rounded-2xl shadow-lg rotate-[-10deg]"/>
                            <img  src={items.image2}  alt="Image 2"  className="lg:h-[400px] lg:w-[250px] xl:w-[300px] xl:h-[400px] lg:top-20 absolute left-35 bottom-28 lg:left-70  xl:h-[370px] xl:w-[275px] lg:w-[200px] md:w-[170px] md:h-[275px]  object-cover rounded-2xl shadow-lg rotate-[10deg] -ml-10"/>
                        </div>
                    </div>
               </div>
             </div>
          </li>
        ))}
          
        </ul>
      </div>
    </div>
  );
};

export default Stack;
